import { DoqType, ResponsiveDoqWithSpeechBubble } from '@ardoq/doq';
import { dispatchAction, connect } from '@ardoq/rxbeach';
import { map } from 'rxjs';
import { EmptyStatesDoqContainer } from '@ardoq/graph';
import * as gridEditorActions from 'gridEditor/actions';
import { t, type I18nLocale } from '@ardoq/i18n';
import { i18nLocale$ } from 'streams/i18nLocale$';

const dispatchShowGridEditor = () => {
  dispatchAction(gridEditorActions.showGridEditor());
};

type NoDataAvailableDoqProps = {
  doqType: DoqType;
  includeActions?: boolean;
  i18nLocale: I18nLocale;
};

const NoDataAvailableDoqBase = ({
  doqType,
  includeActions = true,
  i18nLocale,
}: NoDataAvailableDoqProps) => {
  return (
    <EmptyStatesDoqContainer
      data-testid={`${doqType}-emptystate__no-data-available`}
    >
      <ResponsiveDoqWithSpeechBubble
        doqType={doqType}
        title={t(
          i18nLocale,
          'tabview:graphViews.emptyState.noDataAvailable.title',
          'There is no data to show'
        )}
        message={t(
          i18nLocale,
          'tabview:graphViews.emptyState.noDataAvailable.message',
          'Data can be easily added through the Grid Editor.'
        )}
        buttonLabel={
          includeActions
            ? t(
                i18nLocale,
                'tabview:graphViews.emptyState.noDataAvailable.openGridEditor',
                'Open Grid Editor'
              )
            : undefined
        }
        onButtonClick={includeActions ? dispatchShowGridEditor : undefined}
      />
    </EmptyStatesDoqContainer>
  );
};
export const NoDataAvailableDoq = connect(
  NoDataAvailableDoqBase,
  i18nLocale$.pipe(map(i18nLocale => ({ i18nLocale })))
);
